export default __webpack_public_path__ + "static/media/martina_bosso_smaller_size.1f75fa73.png";